'use strict'; 
import $ from "jquery";
import '../_helpers/loading_indicators';
import emailPasswordSignInForm from '../../templates/sign_in/email-password-form.hbs';
import emailSsoForm from '../../templates/sign_in/email-sso-form.hbs';
import alert from '../_helpers/alert';
import { BaseModel } from "../_models/Base";
import VMJState from "../external/VMJState";

export default function SignInHandler(options) {
    var signInHandler = {
        endpoints: {
            checkMethod: '/functions/sign-in/check-user-method',
            passwordMethod: '/functions/sign-in/handle-password-login'
            // there is no need, currently, for an sso method as the checkMethod will return a redirect for that
        },
        modalTarget: '#sign-in-modal',
        renderTarget: '#login-form-container',
        signInForm: undefined,
        alertContainer: undefined,
        currentState: SignInHandlerStates.PASSWORD,
        isLoading: false,

        init: function() {
            this.renderTarget = $('body').find(this.renderTarget);
            this.modalTarget = $('body').find(this.modalTarget);
            this.renderEmailPasswordForm();
            this.alertContainer = this.modalTarget.find('#alert-container');
            // Event handlers
            this.renderTarget.on('submit', '.login-form-sso', this.handleFormSubmit.bind(this));
            if(this.renderTarget.closest('.modal').length) {
                this.renderTarget.closest('.modal').on('show.bs.modal', this.reset.bind(this));
            }
            this.renderTarget.on('click', '#switch-login-to-sso', this.renderSsoForm.bind(this));
            this.renderTarget.on('click', '#switch-login-to-password', this.renderEmailPasswordForm.bind(this));
            this.reset();

        },
        reset() {
            this.renderTarget.find('#email').val('').focus();
            this.hideLoadingIndicator();
            this.hideAlert();
        },
        // AJAX Handlers
        handleFormSubmit: function(e) {
            e.preventDefault();
            if(this.isLoading) {
                return;
            }
            this.isLoading = true;
            this.disableInputs();
            this.showLoadingIndicator();
            this.hideAlert();
            let _e = this.renderTarget.find('[name="email"]').val();
            if(this.currentState == SignInHandlerStates.PASSWORD) {                
                let _p = this.renderTarget.find('[name="password"]').val()
                this.passwordAjaxRequest(_e, _p);
            } else if(this.currentState == SignInHandlerStates.SSO) {
                this.checkingAjaxRequest(_e);
            }
        },
        checkingAjaxRequest: function(email) {
            ajaxResponse(
                this, 
                this.endpoints.checkMethod, 
                {email:email},
                [this.handleSignInResponse.bind(this), this.enableInputs.bind(this)],
                [this.handleSignInError.bind(this), this.enableInputs.bind(this)], 
                "POST",
                "json",
                this.getSignInConverter()
            );
        },
        passwordAjaxRequest: function(email, password) {
            ajaxResponse(
                this, 
                this.endpoints.passwordMethod, 
                {email:email,password:password},
                [this.handleSignInResponse, this.enableInputs.bind(this)],
                [this.handleSignInError, this.enableInputs.bind(this)], 
                "POST",
                "json",
                this.getSignInConverter()
            );
        },
        handleSignInResponse: function(obj) {
            VMJState.Reset();
            if(obj.success == true) {
                if(obj.redirect == null || obj?.redirect.length == 0) {
                    this.showAlert("Your account does not currently support SSO, please login with your password");
                    return;
                } else if(obj.redirect != null && obj.redirect.length > 0) {
                    window.location = obj.redirect;
                    return;
                } else {
                    this.showAlert('Invalid Email or Password');
                }
            } else {
                this.showAlert(obj.message);
            }
            this.hideLoadingIndicator();
            this.isLoading = false;
        },
        handleSignInError: function(jqXHR) {
            VMJState.Reset();
            this.showAlert(jqXHR.responseJSON.message);
            this.hideLoadingIndicator();
            this.isLoading = false;
        },
        getSignInConverter: function() {
            return {
                'converters': {
                    "text json": function(data) {
                        let response = new SignInResponse();
                        if(data) {
                            data = JSON.parse(data);
                            response = new SignInResponse(data);
                        }
                        return response;
                    }
                }
            }
        },

        // UI Handlers
        renderEmailPasswordForm: function() {
            this.currentState = SignInHandlerStates.PASSWORD;
            let email = this.renderTarget.find('#email').val();
            this.renderTarget.html(emailPasswordSignInForm({email:email}));
            this.modalTarget.find(".modal-title").text("Login");
        },
        renderSsoForm: function() {
            this.currentState = SignInHandlerStates.SSO;
            let email = this.renderTarget.find('#email').val();
            this.renderTarget.html(emailSsoForm({email:email}));
            this.modalTarget.find(".modal-title").text("Single Sign-On");
        },
        disableInputs: function() {
            this.renderTarget.find('[name="email"]').attr('disabled','disabled').addClass('disabled');
            this.renderTarget.find('[name="password"]').attr('disabled','disabled').addClass('disabled');
        },
        enableInputs: function() {
            this.renderTarget.find('[name="password"]').attr('disabled',false).removeClass('disabled');
            this.renderTarget.find('[name="email"]').attr('disabled',false).removeClass('disabled');
        },
        showLoadingIndicator: function() {
            this.renderTarget.showLoadingIndicator();
        },
        hideLoadingIndicator: function() {
            this.renderTarget.removeLoadingIndicator();
        },
        showAlert: function(message) {
            this.alertContainer.html(alert('danger', message,null,false));
            this.alertContainer.removeClass('d-none');
        },
        hideAlert: function() {
            this.alertContainer.html('');
            this.alertContainer.addClass('d-none');
        },
        showModal: function(mode = null) {
            mode ??= SignInHandlerStates.PASSWORD;
            if(mode != SignInHandlerStates.PASSWORD && mode != SignInHandlerStates.SSO) {
                mode = SignInHandlerStates.PASSWORD;
            }
            if(mode == SignInHandlerStates.PASSWORD) {
                this.renderEmailPasswordForm();
            } else if(mode == SignInHandlerStates.SSO) {
                this.renderSsoForm();
            }
            this.modalTarget.modal('show');
        }
    }

    var availableOptions = [

    ];
    for(var i = 0;i < availableOptions.length;i++) {
        let o = availableOptions[i];
        if(options.hasOwnProperty(o) && signInHandler.hasOwnProperty(o)) {
            signInHandler[o] = options[o];
        }
    }

    return signInHandler;
}

class SignInHandlerStates {
    static SSO = 'SSO';
    static PASSWORD = 'PASSWORD';
}

class SignInResponse extends BaseModel {
    success = false;
    redirect = null;
    message = 'Invalid Email or Password';

    constructor(jsonObj) {
        super();
        this.init(jsonObj);
    }
}